import React from "react";
import { Footer, Header, Navbar } from "../../components";
import HeroSection from "./herosection/HeroSection";
import PaketWisata from "./paket/PaketWisata";
import TentangGiliIyang from "./tentangGiliIyang/TentangGiliIyang";
import Contact from "./contact/Contact";

const LandingPage = () => {
    return (
        <>
            <Navbar />
            <HeroSection />
            <Header />
            <PaketWisata />
            <TentangGiliIyang />
            <Contact />
            <Footer />
        </>
    )
}

export default LandingPage;